<template>
<div id="demo-basic-card">
  <div style="display: flex; margin-bottom: 20px; justify-content: flex-end; align-items: flex-end;">
    <vs-select class="selectPracticeType" placeholder="선택하기" label="과목" v-model="select" style="margin-left: 10px;">
      <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item, index) in subjectType" />
    </vs-select>
    <vs-select v-if="selectDetail && select == 4" class="selectPracticeType" placeholder="선택하기" label="사회탐구" v-model="selectResearch" style="margin-left: 10px;">
      <vs-select-item :key="index" :value="item" :text="item.name" v-for="(item, index) in socialDetailType" />
    </vs-select>
    <vs-select v-if="selectDetail && select == 5" class="selectPracticeType" placeholder="선택하기" label="과학탐구" v-model="selectResearch" style="margin-left: 10px;">
      <vs-select-item :key="index" :value="item" :text="item.name" v-for="(item, index) in scienceDetailType" />
    </vs-select>
  </div>
  <vx-card class="box" style="margin-bottom:20px" scrollHeight>
    <vs-collapse>
      <vs-collapse-item id='collapse' scrollHeight>
        <div slot="header">대기</div>
        <div class="vx-row" style="padding:10px">
          <PracticeItem :type="true" v-if="(exam.info == 'high' || exam.info == 'sat') && exam.type_state == 0 && exam.admin_check > 0" v-for="(exam, index) in practiceExamList" :subjectInfo="exam" :selectedId='select' :key="index" />
        </div>
      </vs-collapse-item>
    </vs-collapse>
  </vx-card>
  <vx-card class="box" style="margin-bottom:20px" scrollHeight>
    <vs-collapse>
      <vs-collapse-item id='collapse' scrollHeight>
        <div slot="header">진행</div>
        <div class="vx-row" style="padding:10px">
          <PracticeItem v-if="(exam.info == 'high' || exam.info == 'sat') && exam.type_state == 1 && exam.admin_check > 0 && teacherInfo(exam)" v-for="(exam, index) in practiceExamList" :subjectInfo="exam" :selectedId='select' :key="index"/>
        </div>
      </vs-collapse-item>
    </vs-collapse>
  </vx-card>
  <vx-card class="box" style="margin-bottom:20px" scrollHeight>
    <vs-collapse>
      <vs-collapse-item id='collapse' scrollHeight>
        <div slot="header">완료</div>
        <div class="vx-row" style="padding:10px">
          <PracticeItem v-if="(exam.info == 'high' || exam.info == 'sat') && exam.type_state == 2 && exam.admin_check > 0 && (teacherInfo(exam) || superAdminState)" v-for="(exam, index) in practiceExamList" :subjectInfo="exam" :selectedId='select' :key="index" />
        </div>
      </vs-collapse-item>
    </vs-collapse>
  </vx-card>
  <vx-card v-if="superAdminState == true" class="box" style="margin-bottom:20px" scrollHeight>
    <vs-collapse>
      <vs-collapse-item id='collapse' scrollHeight>
        <div slot="header">지급완료</div>
        <div class="vx-row" style="padding:10px">
          <PracticeItem v-if="(exam.info == 'high' || exam.info == 'sat') && exam.type_state == 3 && exam.admin_check > 0" v-for="(exam, index) in practiceExamList" :subjectInfo="exam" :selectedId='select' :key="index" />
        </div>
      </vs-collapse-item>
    </vs-collapse>
  </vx-card>
</div>
</template>

<script>
import PracticeItem from './PracticeItem.vue'
import SubjectItem from "./exam/SubjectItem.vue"

export default {
  components: {
    'PracticeItem':PracticeItem,
    'SubjectItem': SubjectItem,
  },
  data() {
    return {
      superAdminState : this.$acl.check('superAdmin'),
      title: 'AClass',
      workspacePopup: false,
      subjectInfo: {
        'id': 0,
        'start_time': null,
        'end_time': null,
        'info': 'high',
        'grade': '1',
        'test_name': '',
        'institute': '',
        'state': 0,
        'release_time': '',
        'exam_version': '',
        'total_score': 0
      },
      select: '',
      selectedSubject: '',
      subjectType: [
        {id: 1, name: '국어'},
        {id: 2, name: '영어'},
        {id: 3, name: '수학'},
        {id: 4, name: '사회탐구'},
        {id: 5, name: '과학탐구'},
        {id: 6, name: '한국사'},
      ],
      selectResearch: '',
      socialDetailType: [

      ],
      scienceDetailType: [

      ],
      selectDetail: false,
    }
  },
  created() {
    // console.log(this.activeUser)
    // console.log(this.practiceExamList)
    var index = this.practiceExamList.findIndex((item) => {
      return item.type_state == 1
    })
    if(index != -1){
      // console.log(this.practiceExamList[index])
      console.log(index)
    }
    if (this.adminExamList.length == 0) {
      this.$store.dispatch('etest/getEtestExam', 'admin')
    }
    this.$store.dispatch('etest/getSubjectType')

    this.$store.dispatch('etest/getCategoryList', -1)
    this.$store.dispatch('etest/getMainCategoryList', -1)
    this.$store.dispatch('etest/getSubCategoryList', -1)
  },
  computed: {
    scrollbarTag() {
      return this.$store.getters.scrollbarTag
    },
    writingExamList() {
      return this.$store.state.etest.writingExamList
    },
    scheduleExamList() {
      return this.$store.state.etest.scheduleExamList
    },
    currentExamList() {
      return this.$store.state.etest.currentExamList
    },
    adminExamList() {
      return this.$store.state.etest.adminExamList
    },
    userExamList() {
      return this.$store.state.etest.userExamList
    },
    testExamList() {
      return this.$store.state.etest.testExamList
    },
    // subjectType() {
    //   return this.$store.state.etest.subjectType
    // },
    practiceExamList() {
      return this.$store.state.etest.practiceExamList
    },
    subjectList() {
      return this.$store.state.etest.subjectList
    },
    activeExam() {
      return this.$store.state.etest.activeExam
    },
    activeUser() {
      return this.$store.state.AppActiveUser
    },
    subjectDetailType() {
      return this.$store.state.etest.subjectDetailType
    }
  },
  methods: {
    teacherInfo(exam) {
      return this.activeUser.uid == exam.teacher_id ? true : this.superAdminState ? true : false
    },
  },
  mounted() {
    if(localStorage.getItem(this.selectedSubject)){
      this.select = localStorage.getItem(this.selectedSubject)
    }
  },
  watch: {
    select() {
      if(this.select == 4 || this.select == 5){
        this.socialDetailType = [
          {id: 4,
           name: "통합사회"}
        ]
        this.scienceDetailType = [
          {id: 5,
           name: "통합과학"}
        ]
          this.$store.dispatch('etest/getSubjectDetailType').then(()=> {
            this.selectDetail = true
            console.log(this.subjectDetailType)
            for(var i in this.subjectDetailType.research) {
              if(this.subjectDetailType.research[i].info_type_id == 4) {
                this.socialDetailType.push(this.subjectDetailType.research[i])
                console.log(this.socialDetailType)
              } else {
                this.scienceDetailType.push(this.subjectDetailType.research[i])
              }
            }
          })
        } else {
          this.$store.dispatch('etest/getEpracticeExam', this.select)
          this.selectDetail = false
        }
      localStorage.setItem(this.selectedSubject, this.select)
    },
    selectResearch() {
      if(this.selectResearch.name != '통합사회' && this.selectResearch.name != '통합과학') {
        this.$store.dispatch('etest/getEpracticeResearchExam', this.selectResearch.id)
      } else {
        this.$store.dispatch('etest/getEpracticeExam', this.selectResearch.id)
      }
    }
  },
}
</script>


<style lang="scss">
#demo-basic-card {
    .overlay-card {
        .vx-card__collapsible-content {
            max-height: 705px;
        }
    }
}
</style>


<style lang="scss">
#demo-basic-card {
    .overlay-card {
        .vx-card__collapsible-content {
            max-height: 705px;
        }
    }
}
.selectPracticeType{
  label{
    font-size: 16px;
  }
}
</style>
